import script from "./GamesNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./GamesNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./GamesNavbar.vue?vue&type=style&index=0&id=10569bd3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10569bd3"]])

export default __exports__